/* eslint-disable react/no-unknown-property */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Play } from "lucide-react";
import DarkVeil from "./DarkVeil";

const DarkVeilHeroBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const YOUTUBE_VIDEO_ID = "YiSI7ZkzQfY";

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleScrollToContent = () => {
    const nextSection =
      document.querySelector(".next-section") ||
      document.querySelector("section:nth-of-type(4)") ||
      document.querySelector(".content-section") ||
      document.querySelector("main > div:nth-child(4)");

    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      window.scrollTo({
        top: window.innerHeight * 1.21,
        behavior: "smooth",
      });
    }
  };

  return (
    <section
      className="dark-veil-hero"
      style={{
        position: "relative",
        overflow: "hidden",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
      >
        <DarkVeil
          hueShift={5}
          noiseIntensity={0}
          scanlineIntensity={0}
          speed={1.6}
          scanlineFrequency={0}
          warpAmount={1.2}
          resolutionScale={1}
        />
      </div>

      <div
        className="container"
        style={{ position: "relative", zIndex: 3, padding: "0 15px" }}
      >
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div className="hero-content text-center">
              <div
                className="hero-badge"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "50px",
                  padding: "8px 16px",
                  marginTop: "20px",
                  marginBottom: "20px",
                  backdropFilter: "blur(10px)",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "rgba(255, 255, 255, 0.9)",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                <span>NETWORK MARKETING</span>
              </div>

              <h1
                className="hero-title"
                style={{
                  fontSize: "clamp(3rem, 8vw, 6rem)",
                  fontWeight: "800",
                  lineHeight: "1.1",
                  marginBottom: "30px",
                  color: "#ffffff",
                  textShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
                  maxWidth: "900px",
                  margin: "0 auto 30px",
                }}
              >
                Universal Team ile başarıya ulaşın
              </h1>

              <p
                className="hero-description"
                style={{
                  fontSize: "1.25rem",
                  lineHeight: "1.6",
                  color: "rgba(255, 255, 255, 0.85)",
                  marginBottom: "50px",
                  maxWidth: "650px",
                  margin: "0 auto 50px",
                  fontWeight: "400",
                }}
              >
                Network marketing dünyasında lider olan Universal Team ile
                hayallerinizi gerçekleştirin ve finansal özgürlüğünüze kavuşun.
              </p>

              <div
                className="hero-actions"
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  marginBottom: "80px",
                }}
              >
                <Link
                  to="/register"
                  className="btn-primary"
                  style={{
                    background:
                      "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                    color: "#1a202c",
                    padding: "16px 32px",
                    borderRadius: "50px",
                    textDecoration: "none",
                    fontWeight: "600",
                    fontSize: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.3s ease",
                    border: "none",
                    minWidth: "160px",
                    justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(255, 255, 255, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  Kayıt Ol
                  <ChevronRight size={18} />
                </Link>

                <button
                  className="btn-secondary"
                  onClick={handleOpenModal}
                  style={{
                    background: "transparent",
                    color: "rgba(255, 255, 255, 0.9)",
                    padding: "16px 32px",
                    borderRadius: "50px",
                    fontWeight: "600",
                    fontSize: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    minWidth: "160px",
                    justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <Play size={16} />
                  Nasıl Kayıt Olunur?
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
          onClick={handleCloseModal}
        >
          <div
            style={{
              position: "relative",
              width: "90%",
              maxWidth: "1000px",
              aspectRatio: "16 / 9",
              backgroundColor: "#000",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 15px 50px rgba(0, 0, 0, 0.8)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseModal}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "rgba(255, 255, 255, 0.3)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "24px",
                lineHeight: "1",
                cursor: "pointer",
                zIndex: 10000,
                transition: "background 0.2s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "300",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "rgba(255, 255, 255, 0.5)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)")
              }
            >
              &times;
            </button>

            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1`}
              title="Nasıl Kayıt Olunur Videosu"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ position: "absolute", top: 0, left: 0 }}
            ></iframe>
          </div>
        </div>
      )}

      <style>{`
        .hero-title {
          animation: fadeInUp 1s ease-out;
        }

        .hero-description {
          animation: fadeInUp 1s ease-out 0.2s both;
        }

        .hero-actions {
          animation: fadeInUp 1s ease-out 0.4s both;
        }

        .hero-stats {
          animation: fadeInUp 1s ease-out 0.6s both;
        }

        .hero-badge {
          animation: fadeInUp 1s ease-out 0.1s both;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .hero-actions {
            flex-direction: column;
            align-items: center;
          }

          .btn-primary,
          .btn-secondary {
            width: 100%;
            max-width: 250px;
          }

          .hero-stats {
            gap: 40px !important;
          }
        }

        @media (max-width: 576px) {
          .hero-stats {
            gap: 30px !important;
          }
        }

        html {
          scroll-behavior: smooth;
        }
      `}</style>
    </section>
  );
};

export default DarkVeilHeroBanner;
